const routes = {
  auth: "auth/*",
  authSignup: `/auth/signup`,
  authSignin: `/auth/signin`,
  dashboard: `/dashboard/*`,
  dashboardNavigation: `/dashboard`,
  carEstimate: "/car-estimate",
  upcomingCars: "/upcoming-cars",
  buyNow: "/buy-now",
  liveAuction: "/live-auction",
  carsInNegotiation: "/cars-in-negotiation",
  carsInNegotiationBuyNow: "/cars-in-negotiation-buy-now",
  myGarage: "/my-garage",
  sellMyCar: "/sell-my-car",
  watchList: "/watch-list",
  myOrders: "/my-orders",
  allOrders: `/all-orders`
};

export { routes };
